import React from "react";
import { useEffect, Suspense, lazy } from "react";
import AppRouter from "./routes/AppRouter";
import NovaVersaoBanner from "./components/NovaVersaoBanner";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { createStore, combineReducers } from "redux";
import { AuthContextProvider, useAuth } from './contexts/AuthContext.jsx';
// import { DomainProvider } from '../contexts/DomainContext.jsx';
import rulesReducer from "./reducers/rulesReducer";
// import cookiesReducer from "./reducers/cookiesReducer";
import subDomainReducer from "./reducers/subDomainReducer";
import { Provider } from "react-redux";
import "./utils/hideLoadingMessages.css";
import { GetSubDomain } from "./utils/urlSudDomainUtil";
import Tooltip from "bootstrap/js/dist/tooltip";
import { fixBootstrapModalBackdropIssue } from "./utils/BootstrapFix";
import BootstrapPreloader from "./components/BootstrapPreloader";
import FederacaoNaoFiliadaModal from "./components/FederacaoNaoFiliadaModal";
const ConviteConsentimentoModal = lazy(() => import("./components/crm/ConviteConsentimentoModal"));
// Convite de consentimento (W7) atrás de flag até o jurídico aprovar o texto dos
// termos marketing-v1 / pesquisa-v1 (decisão de 13/10/2026). Desligada, o modal nem
// é baixado e ninguém chama /lgpd/meu-consentimento.
const CONVITE_CONSENTIMENTO = import.meta.env.VITE_CRM_CONVITE_CONSENTIMENTO === 'true';
import { RouterWarningsSuppressor } from "./routes/router.config";
import TemaLegadoProvider from "./theme/TemaLegadoProvider";
import { ehRotaTelao } from "./routes/rotasTelao";
import "react-whatsapp-chat-widget/index.css";
import "./styles/BusySpinnerReact.css";
import "./styles/AccessibilityOverrides.css"; // Proteções de layout para acessibilidade
// SecurityRulesService movido para área administrativa (DeploySecurityRules component)
// import SecurityRulesService from "./services/SecurityRules.service"; // Movido para área administrativa

// Importa o sistema de monitoramento de produção
import './monitoring/ProductionMonitor';
import { useNavigationMonitoring } from './hooks/useProductionMonitoring';

// Importa indicador de sessão em modo tarefa longa
import LongTaskSessionIndicator from './components/LongTaskSessionIndicator';

// Componente interno que tem acesso ao AuthContext
/**
 * Esconde o próprio conteúdo nas rotas de telão.
 *
 * Os widgets flutuantes (acessibilidade, suporte, VLibras, banner de versão)
 * vivem FORA do roteador, então tirar os painéis do `Layout` não bastaria: eles
 * continuariam sobrepostos ao painel — o botão azul de acessibilidade sobre a
 * faixa da primeira quadra é o sintoma. Num telão sem operador, nada disso tem
 * para quem ser útil.
 */
const ForaDoTelao = ({ children }) => {
  const { pathname } = useLocation();
  return ehRotaTelao(pathname) ? null : children;
};

const AppWithAuth = ({ subDomain }) => {
  const { currentUser } = useAuth();
  
  // Ativa o monitoramento de navegação
  useNavigationMonitoring();

  /*
   * Security rules installation
   * DESABILITADO: Use o componente administrativo DeploySecurityRules
   * Acesse: /admin/deploy-security-rules
   */
  // useEffect(() => {
  //   // Instalação de regras movida para interface administrativa
  //   // Acesse: /admin/deploy-security-rules para implantar novas regras
  //   if (currentUser && import.meta.env.MODE === 'development') {
  //     console.log("🔐 [APP] Security rules installation via App.js is DISABLED");
  //     console.log("ℹ️  [APP] Use /admin/deploy-security-rules to deploy new rules via Cloud Functions");

  //     // SecurityRulesService.installsecurityrules()
  //     //   .then(() => {
  //     //     console.log("✅ [APP] Security rules installed successfully");
  //     //   })
  //     //   .catch((error) => {
  //     //     console.error("❌ [APP] Failed to install security rules:", error.message);
  //     //   });
  //   }
  // }, [currentUser]);

  return <AppRouter subDomain={subDomain} />;
};

const HighlighterSpeakerComponent = lazy(() => import("./components/Elementos/HighlighterSpeakerComponent"));
const AccessibilityWidget = lazy(() => import("./components/AccessibilityWidget"));
const SkipToMain = lazy(() => import("./components/SkipToMain"));
const SupportChatManager = lazy(() => import("./components/SupportChat"));
const VLibrasTooltipOverlay = lazy(() => import("./components/VLibrasTooltipOverlay"));
// const WhatsAppWidget = lazy(() => import("react-whatsapp-chat-widget"));
// const synth = window.speechSynthesis;

// Inicialização dos tooltips do Bootstrap
const initTooltips = () => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  [...tooltipTriggerList].map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
};

// const teste = () => {
//   console.log("Teste");   
// };

// const teste2 = (Arg1) => {
//   console.log("Teste2", Arg1);
// }

// const teste3 = {
//   Arg1: "Teste3",
//   Arg2: 123,
//   Arg3: { 
//     SubArg1: "SubTeste3", 
//     SubArg2: 456 
//   }
//   Arg4: [1, 2, 3, 4, 5],
// }


function App() {
  
  // teste();
  // teste2("Teste argumento");

  // EventoService.copyWithNewIDEntidadeVinculada("9IP4cSuHISoOdNd7VIYZ", "qfQ8KCi1JPNxg9w5xmZB");

  // //console.log("App -> removeAccents('ÇçàãáèẽéìĩíòõóùũúÀÃÁÈẼÉÌĨÍòÕÓÙŨÚ')=", removeAccents('ÇçàãáèẽéìĩíòõóùũúÀÃÁÈẼÉÌĨÍòÕÓÙŨÚ'));

  // Aplica a correção para o erro de backdrop do Modal do Bootstrap
  // Usando um sistema de fases para garantir que os menus funcionem
  useEffect(() => {
    // Verifica primeiro se os menus dropdown estão funcionando corretamente
    let dropdownCheckCount = 0;
    
    const checkDropdownsAndFixModal = () => {
      // Verifica se existem dropdowns na página
      const dropdowns = document.querySelectorAll('[data-bs-toggle="dropdown"]');
      
      if (dropdowns.length > 0 || dropdownCheckCount >= 3) {
        // console.log(`Encontrados ${dropdowns.length} elementos dropdown. Aplicando fix do modal.`);
        
        // Só aplica a correção do backdrop após garantir que os dropdowns estão funcionando
        setTimeout(fixBootstrapModalBackdropIssue, 500);
        
        // Inicializa os tooltips depois que o DOM estiver pronto
        initTooltips();
        
        return;
      } else {
        // Ainda não encontrou dropdowns, tenta novamente até um limite
        dropdownCheckCount++;
        setTimeout(checkDropdownsAndFixModal, 1000);
      }
    };
    
    // Inicia a verificação após um período inicial
    const timer = setTimeout(checkDropdownsAndFixModal, 1000);
    return () => clearTimeout(timer);
  }, []);

  /*
  * Portals installation
  */
  // let justOneExecution = useRef(true);
  // useEffect(() => {
  //   // portaisService.installPortals();
  //   // portaisService.installPortalHelpDesk();
  //   if (justOneExecution.current) {
  //     justOneExecution.current = false;
  //     // portaisService.installPortalsDasFederacoes("AsQvewhhLXE65y5ryMPG"); // FPTO

  //   }
  // }, []);

  /*
   * Services Category installation
   */
  // useEffect(() => {
  //   ServiceCategoryService.installServicesCategory();
  // }, []);

  const allReducers = combineReducers({
    userRules: rulesReducer,
    subDomain: subDomainReducer,
  });
  const store = createStore(allReducers);

  const subDomain = GetSubDomain();

  
  return (
    <RouterWarningsSuppressor>
      <Router
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <Provider store={store}>
          {/* Tema para as telas que ainda usam makeStyles do @mui/styles.
              Sem ele, elas quebram em theme.spacing. Ver TemaLegadoProvider. */}
          <TemaLegadoProvider>
          <AuthContextProvider>
            {/* <DomainProvider> */}
              <AppWithAuth subDomain={subDomain} />
            {/* </DomainProvider> */}
            {/* Aviso de portal de federação não filiada (redireciona ou desloga).
                FORA do ForaDoTelao de propósito: é controle de acesso, não
                enfeite. Escondê-lo no telão deixaria um portal de federação não
                filiada exibindo o painel sem o bloqueio que todas as outras
                telas aplicam. */}
            <FederacaoNaoFiliadaModal />

            <ForaDoTelao>
            {/* Outros componentes preguiçosamente carregados */}
            <Suspense fallback={null}>
              <SkipToMain />
            </Suspense>
            <LongTaskSessionIndicator />
            {/* Convite de consentimento (W7). DENTRO do ForaDoTelao: no telão não
                há ninguém para consentir. NÃO é bloqueante — ver a nota no
                componente; condicionar o acesso tornaria o consentimento nulo. */}
            {CONVITE_CONSENTIMENTO && (
              <Suspense fallback={null}>
                <ConviteConsentimentoModal />
              </Suspense>
            )}
            {/* Banner "nova versão disponível" — auto-detecta deploy novo e oferece recarregar */}
            <NovaVersaoBanner />
            <Suspense fallback={<BootstrapPreloader />}>
                <HighlighterSpeakerComponent key="HighlighterSpeakerComponent1" />
                <AccessibilityWidget />
                <SupportChatManager />
                <VLibrasTooltipOverlay />
                {/* <WhatsAppWidget
                  phoneNo="+5561991520525"
                  position="right"
                  widgetWidth="300px"
                  widgetWidthMobile="260px"
                  autoOpen={false}
                  autoOpenTimer={5000}
                  messageBox={true}
                  messageBoxTxt="Olá, como posso te ajudar?"
                  iconSize="40"
                  iconColor="white"
                  iconBgColor="#186cc3"
                  headerIcon="https://cbtkd.org.br/logoname.png"
                  headerIconColor="pink"
                  headerTxtColor="black"
                  headerBgColor="tomato"
                  headerTitle="CBTKD"
                  headerCaption="Estamos online!"
                  bodyBgColor="#bbb"
                  chatPersonName="Suporte CBTKD"
                  chatMessage={<>Olá, como a CBTKD pode te ajudar hoje?</>}
                  footerBgColor="#999"
                  placeholder="Escreva sua mensagem..."
                  btnBgColor="#186cc3"
                  btnTxt="Iniciar Chat"
                  btnTxtColor="white"
                /> */}
              </Suspense>
            </ForaDoTelao>
            </AuthContextProvider>
          </TemaLegadoProvider>
        </Provider>
      </Router>
    </RouterWarningsSuppressor>
  );
}

export default App;
